export function unpackQueryArray(queryArray: undefined): undefined
export function unpackQueryArray(queryArray: string[] | string): string
export function unpackQueryArray(queryArray: string[] | string | undefined): string | undefined
export function unpackQueryArray(queryArray: string[] | string | undefined): string | undefined {
    return Array.isArray(queryArray) ? queryArray[0] : queryArray
}
